import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from 'context/login/authContext';
import '@styles/topbar.css';

const TopBar: React.FC = () => {
  const [cityOpen, setCityOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState('Hyderabad');
  const { logout } = useAuth();
  const username = localStorage.getItem("username") || "Admin";

  const cities = ['Hyderabad', 'Mumbai', 'Guntur'];

  return (
    <section className="home-section">
      <div className="top-bar">
        {/* Left — Greeting */}
        <div className="topbar-left">
          <div className="greeting">
            <span className="greeting-hello">Hello,</span>
            <span className="greeting-name">{username}</span>
          </div>
          <span className="greeting-sub">Here's what's happening today</span>
        </div>

        {/* Center — Search & City */}
        <div className="topbar-center">
          <div className="topbar-search">
            <svg className="topbar-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input type="text" placeholder="Search food courts, orders..." />
          </div>

          {/* City selector */}
          <div className="topbar-city" onClick={() => setCityOpen(!cityOpen)}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            <span>{selectedCity}</span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>
            {cityOpen && (
              <div className="topbar-city-dropdown">
                {cities.map(city => (
                  <button key={city} className={city === selectedCity ? 'active' : ''} onClick={(e) => { e.stopPropagation(); setSelectedCity(city); setCityOpen(false); }}>
                    {city}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Right — Icons */}
        <div className="topbar-right">
          <Link to="/notifications" className="topbar-icon-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
            <span className="topbar-badge"></span>
          </Link>

          {/* Profile */}
          <div className="topbar-profile" onClick={() => setProfileOpen(!profileOpen)}>
            <div className="topbar-avatar">
              {username.charAt(0).toUpperCase()}
            </div>
            <div className="topbar-profile-info">
              <span className="topbar-profile-name">{username}</span>
              <span className="topbar-profile-role">Admin</span>
            </div>
            <svg className="topbar-profile-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>

            {profileOpen && (
              <div className="topbar-profile-dropdown">
                <Link to="/profile" onClick={() => setProfileOpen(false)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                  Profile
                </Link>
                <Link to="/settings" onClick={() => setProfileOpen(false)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
                  Settings
                </Link>
                <div className="topbar-dropdown-divider"></div>
                <button onClick={() => { setProfileOpen(false); logout(); }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopBar;
